/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PalSubmissionPresetCounts
 */
export interface PalSubmissionPresetCounts {
    /**
     * Count of submissions in the Not Submitted preset bucket.
     * @type {number}
     * @memberof PalSubmissionPresetCounts
     */
    notSubmitted: number;
    /**
     * Count of submissions in the In Review preset bucket.
     * @type {number}
     * @memberof PalSubmissionPresetCounts
     */
    inReview: number;
    /**
     * Count of submissions in the Following preset bucket (including the denied-by-admission split).
     * @type {number}
     * @memberof PalSubmissionPresetCounts
     */
    following: number;
}

/**
 * Check if a given object implements the PalSubmissionPresetCounts interface.
 */
export function instanceOfPalSubmissionPresetCounts(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "notSubmitted" in value;
    isInstance = isInstance && "inReview" in value;
    isInstance = isInstance && "following" in value;

    return isInstance;
}

export function PalSubmissionPresetCountsFromJSON(json: any): PalSubmissionPresetCounts {
    return PalSubmissionPresetCountsFromJSONTyped(json, false);
}

export function PalSubmissionPresetCountsFromJSONTyped(json: any, ignoreDiscriminator: boolean): PalSubmissionPresetCounts {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'notSubmitted': json['notSubmitted'],
        'inReview': json['inReview'],
        'following': json['following'],
    };
}

export function PalSubmissionPresetCountsToJSON(value?: PalSubmissionPresetCounts | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'notSubmitted': value.notSubmitted,
        'inReview': value.inReview,
        'following': value.following,
    };
}

